import { PeriodType } from "@utils/common/PeriodTypeEnum";

interface HomeAwayScoreLike {
	home?: number;
	away?: number;
}

interface OfferHistoryResultLike {
	fullTimeScore?: HomeAwayScoreLike;
	overTimeScore?: HomeAwayScoreLike;
	scorePerPeriod?: Array<HomeAwayScoreLike & { periodType?: string }>;
}

export interface OfferHistoryScorePart {
	home: number;
	away: number;
}

export interface OfferHistoryScore {
	fullTime: OfferHistoryScorePart | null;
	overTime: OfferHistoryScorePart | null;
	penalties: OfferHistoryScorePart | null;
	total: OfferHistoryScorePart;
}

function toScorePart(
	score: HomeAwayScoreLike | undefined | null
): OfferHistoryScorePart | null {
	if (score == null) {
		return null;
	}

	return { home: score.home ?? 0, away: score.away ?? 0 };
}

export function getOfferHistoryScore(
	result: OfferHistoryResultLike | undefined
): OfferHistoryScore {
	const fullTime = toScorePart(result?.fullTimeScore);
	const overTime = toScorePart(result?.overTimeScore);

	const penaltyPeriod = result?.scorePerPeriod?.find(
		(period) => period.periodType === PeriodType.PEN
	);

	return {
		fullTime,
		overTime,
		penalties: toScorePart(penaltyPeriod),
		total: {
			home: (fullTime?.home ?? 0) + (overTime?.home ?? 0),
			away: (fullTime?.away ?? 0) + (overTime?.away ?? 0),
		},
	};
}

export function withoutOvertimeAndPenalties<T>(
	scorePerPeriod: T[] | undefined
): T[] | undefined {
	return scorePerPeriod?.filter((period) => {
		const { periodType } = period as { periodType?: string | null };

		return periodType !== PeriodType.OT && periodType !== PeriodType.PEN;
	});
}
